import React from 'react';
import { useSelector } from 'react-redux';

import { GlossaryState } from 'common/modules/app/glossaries';
import { Glossary } from 'common/utils/glossary';
import { getPlanListUrl, sasStaticUrl } from 'common/utils/urls';

import { Footer } from 'common/components';

import { AppState } from 'pages';

// StoreのStateからComponentに渡すPropsへ
const useStateProps = () => {
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );

  return {
    glossary: Glossary.instance(glState)
  };
};

// Actionをdispatchする関数からComponentに渡すPropsへ
const useDispatchProps = () => {
  /** プラン一覧の押下処理 */
  const onClickPlanList = () => {
    window.location.href = getPlanListUrl();
  };

  /** 利用ガイドの押下処理 */
  const onClickGuide = () => {
    // 利用ガイドを別タブで開く
    window.open(`${sasStaticUrl}/st/guide.html`);
  };

  /** FAQの押下処理 */
  const onClickFaq = () => {
    // FAQを別タブで開く
    window.open(`${sasStaticUrl}/st/faq.html`);
  };

  /** お問い合わせの押下処理 */
  const onClickContact = () => {
    // お問い合わせを別タブで開く
    window.open(`${sasStaticUrl}/st/contacts.html`);
  };

  /** 利用規約の押下処理 */
  const onClickTermsOfService = () => {
    // 利用規約を別タブで開く
    window.open(`${sasStaticUrl}/st/term-of-use.html`);
  };

  /** プライバシーポリシーの押下処理 */
  const onClickPrivacyPolicy = () => {
    // プライバシーポリシーを別タブで開く
    window.open('https://myid.canon/canonid/#/policy');
  };

  /** クッキーポリシーの押下処理 */
  const onClickCookiePolicy = () => {
    // クッキーポリシーを別タブで開く
    window.open(`${sasStaticUrl}/st/cookie-policy.html`);
  };

  return {
    onClickPlanList: onClickPlanList,
    onClickGuide: onClickGuide,
    onClickFaq: onClickFaq,
    onClickContact: onClickContact,
    onClickTermsOfService: onClickTermsOfService,
    onClickPrivacyPolicy: onClickPrivacyPolicy,
    onClickCookiePolicy: onClickCookiePolicy
  };
};

export default function ContainerComponent() {
  const _props = { ...useStateProps(), ...useDispatchProps() };
  return <Footer {...{ ..._props }} />;
}
